import client from '@/lib/http-client';

const endpoint = 'admin';

export default {
	create(params, cb, errorCb) {
		const url = `${endpoint}/create_oo_account`;
		client
			.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},
};
